<div class="box">
    <div class="myForm">
        <div class="card">
            <h4 class="card-header">Ship Activity</h4>
            <div class="card-body scroll">
                <form #shipForm="ngForm" (ngSubmit)="getRes()">
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Client</mat-label>
                            <mat-select name="client" placeholder="Client" [(ngModel)]="ship.client" required>
                                <mat-option *ngFor="let item of clients" [value]="item.id">{{
                                    item.dname
                                    }}</mat-option>
                            </mat-select>
                            <mat-error>*Client is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Ship ID</mat-label>
                            <input matInput [(ngModel)]="ship.id" type="text" name="shipID"
                                required />
                            <mat-error>*Ship ID is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field class="width" appearance="outline">
                            <mat-label>From Date - To Date</mat-label>
                            <mat-date-range-input [rangePicker]="picker" [max]="currDate">
                              <input matStartDate matInput [(ngModel)]="ship.from" name="from"  placeholder="From date" required />
                              <input matEndDate matInput [(ngModel)]="ship.to" name="to" placeholder="To date" required />
                            </mat-date-range-input>
                            <mat-error>*Date Range is required</mat-error>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                          </mat-form-field>
                    </p>
                    <p>
                        <button color="primary" class="button" [disabled]="!shipForm.valid || buttonClicked"
                            type="submit" mat-raised-button>
                            {{ buttonClicked ? "Getting File" : "Submit" }}
                            <span>
                                <mat-icon *ngIf="buttonClicked">
                                    <mat-spinner diameter="25"></mat-spinner>
                                </mat-icon>
                            </span>
                        </button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</div>
